import qs from 'qs';
import keyBy from 'lodash/keyBy';
import { REASONS, REASON_CODES } from '../../constants/endpoints';

export const RECEIVE_REASONS_MAP = 'RECEIVE_REASONS_MAP';
export const RECEIVE_SIMPLE_REASON_IDS = 'RECEIVE_SIMPLE_REASON_IDS';
export const RECEIVE_ACTION_TYPE_REASONS = 'RECEIVE_ACTION_TYPE_REASONS';
export const RECEIVE_IS_FETCHING_REASONS = 'RECEIVE_IS_FETCHING_REASONS';

const REASON_ID_KEY = 'return_reason_code_id';

export const fetchSimpleReasons = () => async (dispatch, getState) => {
  try {
    const {
      page: { locale, browserFingerprint },
      retailerSettings: { name: retailerName },
      reasons: { reasonsMap },
    } = getState();

    const params = qs.stringify({ locale });
    const response = await fetch(REASON_CODES({ retailerName, params }), {
      method: 'GET',
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    });
    const { reason_codes: apiReasons, error_response: apiErrorMsg } = await response.json();

    if (!apiReasons || !apiReasons.length) {
      throw new Error(apiErrorMsg || 'Return Reason Codes Error');
    }

    const incomingReasonsMap = keyBy(apiReasons, REASON_ID_KEY);
    const simpleReasonIds = apiReasons.map((reason) => reason[REASON_ID_KEY]);

    dispatch({
      type: RECEIVE_REASONS_MAP,
      data: {
        reasonsMap: {
          ...reasonsMap,
          ...incomingReasonsMap,
        },
      },
    });

    return dispatch({
      type: RECEIVE_SIMPLE_REASON_IDS,
      data: {
        simpleReasonIds,
      },
    });
  } catch (err) {
    return console.error(err); // eslint-disable-line no-console
  }
};

const partitionReasons = (reasons) => {
  const partitioned = {};

  reasons.forEach((reason) => {
    reason.items.forEach((item) => {
      const itemId = item.item_id;
      if (!partitioned[itemId]) {
        partitioned[itemId] = {};
      }

      reason.actions.forEach((action) => {
        if (!partitioned[itemId][action]) {
          partitioned[itemId][action] = [];
        }

        if (item.eligible) {
          partitioned[itemId][action].push({
            action_reason_id: reason.reason_id,
            display: reason.display
              ? {
                  ...reason.display,
                  fields: reason.display.fields
                    ? reason.display.fields.sort((a, b) => a.display_order - b.display_order)
                    : [],
                }
              : reason.display,
            eligible_quantity: item.eligible_quantity,
            disabled: item.eligible_quantity < 1,
          });
        } else {
          item.ineligibility_reasons.forEach((ineligibilityReason) => {
            partitioned[itemId][action].push({
              action_reason_id: reason.reason_id,
              display: reason.display,
              disabled: true,
              message: ineligibilityReason.text?.value || '',
              quantity: ineligibilityReason.quantity,
            });
          });
        }
      });
    });
  });

  return partitioned;
};

export const fetchActionTypeReasons = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: RECEIVE_IS_FETCHING_REASONS,
      data: {
        isFetching: true,
      },
    });
    const {
      retailerSettings: { name: retailerName } = {},
      landingPage: { landingForm: { email } } = {},
      page: { locale } = {},
      orderInfo: { currentOrderNumber: orderNumber } = {},
    } = getState();

    const response = await fetch(
      REASONS({
        retailerName,
        orderNumber,
        params: qs.stringify({ email, locale }),
      }),
    );
    const data = await response.json();
    const partitioned = partitionReasons(data);

    dispatch({
      type: RECEIVE_ACTION_TYPE_REASONS,
      data: {
        actionTypeReasonsByItemId: partitioned,
      },
    });
  } catch (err) {
    console.log(err);
  } finally {
    dispatch({
      type: RECEIVE_IS_FETCHING_REASONS,
      data: {
        isFetching: false,
      },
    });
  }
};
